// React
import React, { Component } from "react";
import { connect } from "react-redux";
// Routing
import { withRouter } from "react-router-dom";
// Translations
import { withTranslation } from "react-i18next";
// Material
import { CircularProgress, Divider } from "@material-ui/core";
// Views
// Infrastructure
import { IntegrationsAPI } from "views/Integrations/infrastructure";
// Components
import { Button } from "@components/Input";
import { ElementsCustom } from "@components/Elements";
import { AlertInfo } from "@components/Alert";
import { showNotify } from "vendor/application/disptach";
// Assets
import { channelsSvg } from "assets";
import { arrowRightSvg } from "@assets";
// Styles
import "../../../styles/styles.scss";

class Create extends Component {
  constructor(props) {
    super(props);
    this.state = {
      integration: {
        channel: "sunco_campaigns",
        info: {
          app: {
            id: "",
            key_id: "",
            key_secret: ""
          }
        }
      },
      loading_integration: false
    };
  }

  updateElement = (e, domain, type) => {
    const { integration } = this.state;
    integration.info[domain][type] = e.target.value;
    this.setState({ integration: integration });
  };

  return = () => {
    const { history } = this.props;
    history.push("/integrations/sunco_campaigns");
  };

  postIntegration = async (e) => {
    e.preventDefault();
    const { access, user } = this.props.data;
    const { history } = this.props;
    const { integration } = this.state;
    try {
      const obj = new IntegrationsAPI(
        user.account_id,
        access,
        this.props,
        integration
      );
      let res = await obj.post_integration();

      this.props.dispatch(
        showNotify({
          from: "integrations",
          type: "create",
          severity: "success"
        })
      );
      history.push(`/integrations/sunco_campaigns/edit/${res.id}`);
    } catch (err) {
      this.props.dispatch(showNotify({ message: err, severity: "error" }));
    }
  };

  handleRender = () => {
    const { t } = this.props;
    const { plan } = this.props.data;
    if (!plan.plan.integrations.sunco_campaigns) {
      return (
        <div
          className={
            "cen_channels_integration_element cen_channels_integration_alert"
          }
        >
          <AlertInfo
            className={"alert"}
            text={t("channels:sunco_campaigns.integrate.alert_plan")}
          />
        </div>
      );
    }
    return this.renderElements();
  };

  renderElements = () => {
    const { t } = this.props;
    const { integration } = this.state;
    return (
      <div
        className={
          "cen_channels_integration_element cen_channels_integration_apiKey"
        }
      >
        {/* AP KEY INFO */}
        <div className={"cen_channels_integration_apiKey_content"}>
          {/* APP ID*/}
          <ElementsCustom
            t={t}
            type={"sunco_campaigns"}
            input_type={"input"}
            element_type={"id"}
            element={integration.info.app.id}
            updateElement={(e) => this.updateElement(e, "app", "id")}
          />
          <Divider />
          {/* API KEY ID*/}
          <ElementsCustom
            t={t}
            type={"sunco_campaigns"}
            input_type={"input"}
            element_type={"api_key_id"}
            element={integration.info.app.key_id}
            updateElement={(e) => this.updateElement(e, "app", "key_id")}
          />
          <Divider />
          {/* API KEY SECRET */}
          <ElementsCustom
            t={t}
            type={"sunco_campaigns"}
            input_type={"input"}
            element_type={"api_key_secret"}
            element={integration.info.app.key_secret}
            updateElement={(e) => this.updateElement(e, "app", "key_secret")}
          />
        </div>
      </div>
    );
  };

  render() {
    const { isSending, plan } = this.props.data;
    const { t } = this.props;
    return (
      <div className={"cen_integrations"}>
        <div className={"header"}>
          <div className={"header_content"}>
            <div onClick={() => this.return()} className={"header_action"}>
              {arrowRightSvg()}
            </div>
            <div className={"header_image"}>{channelsSvg("sunco")}</div>
            <div className={"header_title"}>
              <span className={"title"}>
                {t("integrations:channels.sunco_campaigns.title")}
              </span>
              <span className={"description"}>
                {t("integrations:categories.customer")}
              </span>
            </div>
          </div>
          <div className={"header_actions"}>
            {isSending ? (
              <Button
                type={"primary"}
                disabled
                text={<CircularProgress size={21} />}
              />
            ) : (
              <Button
                type={"primary"}
                disabled={!plan.plan.integrations.sunco_campaigns}
                text={t("channels:sunco_campaigns.integrate.actions.create")}
                onClick={(e) => {
                  this.postIntegration(e);
                }}
              />
            )}
          </div>
        </div>
        <div className={"integration"}>{this.handleRender()}</div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    data: state
  };
};

const connect_app = connect(mapStateToProps)(Create);

export default withTranslation(["commons", "channels", "notifications"])(
  withRouter(connect_app)
);
